import React from 'react';

const QuizResultsPage = ({ page, lesson, quizAnswers, checkpoint, quizResults, onNext, onRetake }) => {
  
  const results = quizResults && quizResults[page.checkpointId] 
    ? quizResults[page.checkpointId]
    : { 
        score: 0, 
        passed: false, 
        correct: 0, 
        total: 0,
        loading: true 
      };

  if (results.loading) {
    return (
      <div className="text-center py-8">
        <h2 className="text-3xl font-bold mb-4 text-gray-800">Checkpoint Results</h2>
        <div className="mb-6">
          <p className="text-gray-600">Calculating results...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center py-8">
      <h2 className="text-3xl font-bold mb-4 text-gray-800">Checkpoint Results</h2>
      
      <div className="mb-6">
        <div className="text-6xl font-bold mb-2 text-primary">
          {results.score}%
        </div>
      </div>

      {results.passed ? (
        <div className="mb-4">
          <div className="text-6xl text-green-600">
            ✓
          </div>
        </div>
      ) : (
        <div className="bg-red-100 border border-red-500 rounded-lg p-6 mb-4">
          <p className="text-red-800 font-semibold text-xl">
            You need {checkpoint?.passingScore || 80}% to pass. Please try again.
          </p>
        </div>
      )}

      {checkpoint?.allowRetake && !results.passed && (
        <button 
          onClick={onRetake}
          className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Retake Checkpoint
        </button>
      )}
    </div>
  );
};

export default QuizResultsPage;

